import { useEffect, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import {
  usePostCreateUOMMutation
} from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import {
  useGetItemDetailsDataMutation,
} from "../../../../store/api/itemapi";
import FileAttachmentManagerViewPage  from "../../../../Components/FileAttachmentManagerViewPage";
import Attachment from "../../../../utils/Attachment";
const ViewForm = () => {
   const location = useLocation();
      const IdData = location.state?.ItemId;
      const [podata, setpodata] = useState('')
      // console.log('details:',IdData)
    const navigate = useNavigate();
  const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

  // api varibale
  const [Createuom] = usePostCreateUOMMutation();

  // tab1
  const [ischeckboxEnabled, setischeckboxEnabled] = useState("");
  const [Whole_Number, setWhole_Number] = useState("");
  const [UOMName, setUOMName] =useState("");

  
  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
    ischeckboxEnabled: false,
    Whole_Number: false,
    UOMName: false,
  });
const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
 const [status, setStatus] = useState("");
 const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();
 
     useEffect(() => {
         if (IdData) {
             itemDetails({ doctype: 'UOM', name: IdData })
                 .unwrap()
                 .then((response) => {
                   const item = response.docs?.[0]; // ✅ safely access first item
  const docinfo = response.docinfo;

  if (!item) return;
                     setpodata(response)
                    //  console.log(item, "Api response");
                     setischeckboxEnabled(item.enabled);
                     setWhole_Number(item.must_be_whole_number);
                     setUOMName(item.uom_name);
                    setStatus(item.enabled)
                     setAttachmentsList(docinfo.attachments); // ✅ Correct place
                 })
                 .catch((err) => {
                     console.error('API Error:', err);
                 });
         } else {
             console.warn('No Id Data found in location state');
         }
     }, [IdData, itemDetails]);

  
  return (
    <FormLayoutTwo
      title="View UOM"
      breadcrumbs={[
        { label: "UOM" },
        { label: "UOM List", url: "/master/uom/uom-list" },
      ]}
       status={'hide'}
      finalStep={finalstep}
      actionButtons={
       <>
          {/* <Button
            to="/master/uom/uom-list"
            className="createbtn d-flex"
            style={{ gap: "2px", height: "28px" }}
            iconName="GrFormPrevious"
            iconSize={12}
          >
            Back
          </Button> */}

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>

            
             {/* <FileAttachmentManagerViewPage
  doctype="UOM"
  docname={IdData}
  attachments={AttachmentsList}
  setAttachments={setAttachmentsList}
/> */}
         <Attachment doctype="UOM"  docname={IdData}  />    

          </div>
        </div>

       <div className=" " style={{ background: '' }}>
          <div className="row">
            <div className="col-12">
              <div >
                <Tab1
                    ischeckboxEnabled={{
                      ischeckboxEnabled: ischeckboxEnabled,
                      setischeckboxEnabled: setischeckboxEnabled,
                      ischeckboxEnabled: ischeckboxEnabled,
                      Error: fieldErrors.ischeckboxEnabled,
                    }}
                    Whole_Number={{
                      Whole_Number: Whole_Number,
                      setWhole_Number: setWhole_Number,
                      Whole_Number: Whole_Number,
                      Error: fieldErrors.Whole_Number,
                    }}
                    UOMName={{
                      UOMName: UOMName,
                      setUOMName: setUOMName,
                      UOMName: UOMName,
                      Error: fieldErrors.UOMName,
                    }}
                    
                  />
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayoutTwo>
  );
};

export default ViewForm;
